import { useState } from "react";
import { CONTACT } from "@/lib/products";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import BrandLogo from "@/components/site/BrandLogo";

const links = [
  { href: "/#personalize", label: "Personalize" },
  { href: "/catalog", label: "Catalog", route: true },
  { href: "/corporate", label: "Corporate & Bulk", route: true },
  { href: "/about", label: "Our Story", route: true },
  { href: "/#faq", label: "FAQ" },
  { href: "/#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-40 glass-strong border-b border-white/5" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-10 h-16 md:h-20">
        <Link to="/" className="flex items-center gap-3 no-tap-highlight" data-testid="brand-home-link">
          <BrandLogo size={36} />
          <div className="leading-tight">
            <div className="font-display text-xl md:text-2xl gold-gradient-text">Shine on Coin</div>
            <div className="text-[10px] tracking-widest-2 uppercase text-white/50">{CONTACT.tagline}</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            l.route ? (
              <Link
                key={l.href}
                to={l.href}
                className="text-sm text-white/70 hover:text-[#d4af37] transition-colors"
                data-testid={`nav-${l.label.toLowerCase().replace(/[\s&]+/g, "-")}`}
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.href}
                href={l.href}
                className="text-sm text-white/70 hover:text-[#d4af37] transition-colors"
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </a>
            )
          ))}
          <a
            href="/#personalize"
            className="rounded-full px-5 py-2 bg-[#d4af37] text-black font-medium text-sm hover:brightness-110 transition"
            data-testid="nav-order-cta"
          >
            Order Custom
          </a>
        </nav>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass-strong border-t border-white/5">
          <div className="px-5 py-4 flex flex-col gap-4">
            {links.map((l) => (
              l.route ? (
                <Link
                  key={l.href}
                  to={l.href}
                  onClick={() => setOpen(false)}
                  className="text-white/80 hover:text-[#d4af37]"
                  data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[\s&]+/g, "-")}`}
                >
                  {l.label}
                </Link>
              ) : (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-white/80 hover:text-[#d4af37]"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </a>
              )
            ))}
            <a
              href="/#personalize"
              onClick={() => setOpen(false)}
              className="mt-2 text-center rounded-full px-5 py-2 bg-[#d4af37] text-black font-medium"
              data-testid="mobile-order-cta"
            >
              Order Custom
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
